(function () {
  // Shows the sticky bar once the real buy-buttons block has scrolled
  // above the viewport (the shopper scrolled past it going down), hides it
  // again once that block is back in view (scrolling back up, or on load
  // before they've reached it at all).
  //
  // Plain scroll-listener + getBoundingClientRect, not IntersectionObserver
  // - simpler to reason about and avoids relying on an observer firing its
  // first callback promptly in every browser/webview this runs in.
  const bars = new Map(); // bar element -> anchor element

  function checkAll() {
    bars.forEach((anchor, bar) => {
      const rect = anchor.getBoundingClientRect();
      // off screen either way: not reached yet (below the fold on a phone)
      // or already scrolled past - the floating buttons stand in until the
      // real ones are in view (owner 2026-10-23, after Brilliant Earth)
      const scrolledPast = rect.bottom < 0 || (window.innerWidth < 750 && rect.top > window.innerHeight);
      if (scrolledPast === bar.classList.contains('is-visible')) return; // no change
      // Only a class flip: the bar is always rendered (no [hidden] toggle)
      // and page padding is static CSS - nothing here changes layout, so
      // iOS has nothing to re-anchor the scroll position against.
      bar.classList.toggle('is-visible', scrolledPast);
      bar.setAttribute('aria-hidden', String(!scrolledPast));
    });
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      checkAll();
      ticking = false;
    });
  }

  function init() {
    document.querySelectorAll('[data-pwp-sticky-bar]').forEach((bar) => {
      if (bars.has(bar)) return;
      const sectionId = bar.id.replace('pwp-sticky-bar-', '');
      const realButtons = document.querySelector(`#ProductSubmitButton-${sectionId}`);
      if (!realButtons) return;
      const anchor = realButtons.closest('.product-form') || realButtons;
      bars.set(bar, anchor);
      // Reserve room for the floating buttons at the very bottom of the page
      // so the footer's last row isn't under them. Measured ONCE here at
      // load - never during scroll, where a height change makes iOS jump.
      // (The CSS :has() padding is the fallback if this never runs.)
      // Where the buttons sit when shown = their current box minus the
      // slide-off transform (the bar starts translated off-screen).
      const ty = new DOMMatrixReadOnly(getComputedStyle(bar).transform).m42 || 0;
      const btns = bar.querySelector('.product-form__buttons') || bar;
      const fromBottom = window.innerHeight - (btns.getBoundingClientRect().top - ty);
      document.body.style.paddingBottom = Math.ceil(fromBottom + 16) + 'px';
    });
    checkAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Dawn re-fetches and swaps the whole product-info section on variant
  // change (metal/size), which replaces this bar's own markup too - the
  // old bar/anchor pair is now stale DOM, drop it and pick up the new one.
  function reinit() {
    bars.clear();
    init();
  }
  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('product-info:loaded', reinit);
})();
